// Unpublished Work © 2020-2025 Deere & Company.

import {ApplicationStatus} from './application-status';
import {FacetOptions} from './facets/facet-options';
import {SelectedFacets} from './facets/selected-facets';
import {SearchPreferences} from './facets/search-preferences';
import {Customers} from '../customer';
import {MergeCustomer} from './merge-customer';
import t from 'tcomb';
import * as searchValidation from '../../../services/customer-search-validation';

export const MinimumCharacterLimitForEmail = 6;
export const MinimumCharacterLimitForPhone = 6;
export const MinimumCharacterLengthForDBSNumber = 1;
export const MinimumRequiredCRMIdLength = 5;
export const MaximumLengthForCRMId = 20;
export const REQUIRED_ENTITY_ID_LENGTH = 9;
export const REQUIRED_REWARDS_NUMBER_LENGTH = 9;

export const CustomerSearch = t.struct({
    applicationStatus: ApplicationStatus,
    customers: Customers,
    facetOptions: FacetOptions,
    mergeCustomer: MergeCustomer,
    savedSearchPreferences: SearchPreferences,
    selectedFacets: SelectedFacets
}, {
    defaultProps: {
        applicationStatus: new ApplicationStatus({}),
        customers: [],
        facetOptions: new FacetOptions({}),
        mergeCustomer: new MergeCustomer({}),
        savedSearchPreferences: new SearchPreferences({}),
        selectedFacets: new SelectedFacets({})
    },
    name: 'CustomerSearch',
    strict: true
});

CustomerSearch.prototype.isValidationAndMinimumCriteriaMet = function () {
    return Boolean(searchValidation.getValidFacetKey(this.selectedFacets, this.facetOptions));
};
